import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/user_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  screen_name_cont: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'screenName',
  },
  miapay_wallet_holder_phone_cont: {
    model_name: 'Miapay::WalletHolder',
    column_type: 'string',
    column_name: 'phone',
  },
  verification_state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'User',
      options: ['init', 'pending', 'approved', 'rejected'],
    },
    model_name: 'User',
    column_name: 'verificationState',
  },
  verification_state_in: {
    column_type: 'enum',
    extra: {
      model_name: 'User',
      options: ['init', 'pending', 'approved', 'rejected'],
    },
    model_name: 'User',
    column_name: 'verificationState',
  },
  is_block_eq: {
    column_type: 'boolean',
    model_name: 'User',
    column_name: 'isBlock',
  },
  first_name_cont: {
    model_name: 'Profile',
    column_type: 'string',
    column_name: 'firstName',
  },
  last_name_cont: {
    model_name: 'Profile',
    column_type: 'string',
    column_name: 'lastName',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('User', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('User', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
